export default __webpack_public_path__ + "static/media/lab_station.e66116cb.jpg";